__webpack_require__.p = "https://eyeprocessorsite.affarintech.com/";